import { Fragment } from "react/jsx-runtime";
import { Grid, TableRow } from "@mui/material";
import { ReportsNoItemsSection } from "../../components";
import { GenericTable } from "~/components/GenericTable/GenericTable";
import {
  ImpactCell,
  PublishedCell,
  RiskFactorsCell,
  TitleCell,
} from "~/components/Cells";
import { UseCveOrAdvisoryReportReturnObject } from "../hooks/useCveOrAdvisoryReport";
import { ScoreRating } from "~/operations";
import { DynamicIcon } from "~/components/icons/DynamicIcon";
import { ReportsSectionHeading } from "~/pages/reports/components/ReportsSectionHeading";

interface AffectedAssetsProps {
  affectedAssets: UseCveOrAdvisoryReportReturnObject["data"]["affectedAssets"];
}

export function CveOrAdvisoryReportExposedAssets({
  affectedAssets,
}: AffectedAssetsProps) {
  const noExposedAssets = affectedAssets && affectedAssets.length < 1;

  return (
    <Fragment>
      <ReportsSectionHeading heading="Exposed assets" />
      <Grid size={12} sx={{ my: 3 }}>
        {noExposedAssets ? (
          <ReportsNoItemsSection target="exposed assets" />
        ) : (
          <GenericTable
            items={0}
            tableName="ADVISORY_REPORT_AFFECTED_ASSETS"
            validSortFields={[]}
            printView
          >
            {affectedAssets?.map((asset) => {
              return (
                <TableRow key={asset?.id}>
                  <ImpactCell
                    impact={asset?.score || 0}
                    rating={asset?.rating || ScoreRating.Critical}
                    isActive
                    hideTooltip
                  />
                  <TitleCell
                    title={asset?.title || ""}
                    icon={<DynamicIcon iconId={asset?.iconId} />}
                    tags={asset?.tags}
                    options={{ fontSize: 14 }}
                  />
                  <RiskFactorsCell riskFactors={asset?.riskFactors} printView />
                  <PublishedCell
                    date={asset?.lastUpdated || "Never"}
                    formatting="absolute"
                  />
                </TableRow>
              );
            })}
          </GenericTable>
        )}
      </Grid>
    </Fragment>
  );
}
